import React, { useEffect, useState } from 'react';
import { ComponentErrorBoundary, toFormattedDate } from '@app/utilities';
import { RateModel } from '@app/sdk';
import { RateEditForm } from './RateEditForm';

export function AddUpdateRate({ selectedRate }: { selectedRate: RateModel }) {
  const [rate, setRate] = useState<RateModel>();
  useEffect(() => {
    if (!selectedRate) {
      setRate(null);
      return;
    }
    setRate({
      ...selectedRate,
      rate: selectedRate.rate * 100,
      effectiveDate: toFormattedDate(selectedRate.effectiveDate),
      announcementDate: toFormattedDate(selectedRate.announcementDate),
    });
  }, [selectedRate]);

  return (
    <ComponentErrorBoundary>
      <div className={'ui segment'}>
        <RateEditForm key={JSON.stringify(rate)} rate={rate}></RateEditForm>
      </div>
    </ComponentErrorBoundary>
  );
}
